import restApi from '@services/api';
import { GenericApiResponse } from '@type/general';
import { ApiTags } from '@constants/common';

import {
  CreatePreIPORequest,
  GetPreIPOResponse,
  PreIPODeals,
  PreIPOResponse,
  QuickLinkEntry,
  UpdatePreIPORequest
} from './types';

const GetPreIPOApi = restApi.injectEndpoints({
  endpoints: builder => ({
    getPreIPO: builder.query<PreIPODeals, { dealId?: string }>({
      query: payload => ({
        url: `${process.env.REACT_APP_BASE_API_VERSION}/support/pre-ipo/${payload.dealId}`,
        method: 'GET'
      }),
      transformResponse: (response: GetPreIPOResponse) => response.result
    }),
    createPreIPO: builder.mutation<PreIPOResponse, CreatePreIPORequest>({
      query: payload => ({
        url: `${process.env.REACT_APP_BASE_API_VERSION}/support/pre-ipo`,
        method: 'POST',
        body: payload
      }),
      invalidatesTags: [ApiTags.preIPOList],
      transformResponse: (response: PreIPOResponse) => response
    }),
    updatePreIPO: builder.mutation<PreIPOResponse, UpdatePreIPORequest>({
      query: payload => ({
        url: `${process.env.REACT_APP_BASE_API_VERSION}/support/pre-ipo`,
        method: 'POST',
        body: payload
      }),
      invalidatesTags: [ApiTags.preIPOList]
    }),

    //Tab4: DataRoom API calls
    getPreIPOQuickLinkEntries: builder.query<QuickLinkEntry, void>({
      query: () => ({
        url: `${process.env.REACT_APP_BASE_API_VERSION}/support/quick-link`,
        method: 'GET'
      }),
      transformResponse: (response: GenericApiResponse<QuickLinkEntry>) =>
        response.result
    })
  })
});

export const {
  useCreatePreIPOMutation,
  useUpdatePreIPOMutation,
  useGetPreIPOQuickLinkEntriesQuery,
  useLazyGetPreIPOQuery
} = GetPreIPOApi;
